document.addEventListener('DOMContentLoaded', () => {
  let menuitems = [...document.getElementsByClassName('header__menu-link')];
  let submenus = [...document.getElementsByClassName('submenu')];
  let mobileNavi = document.getElementById('header-mobile-menu');
  let menuIcon = document.getElementById('header-menu-icon');
  let dropdowns = [...document.getElementsByClassName('header-mobile__icon')];
  let mobileSubmenus = [...document.getElementsByClassName('header-mobile__submenu')];
  let hamburgerIcon = document.getElementById('header-mobile-hamburger');
  let closeIcon = document.getElementById('header-mobile-close');

  menuitems.forEach((item, index) => {
    item.addEventListener('mouseenter', () => {
      submenus.forEach(menu => {
        menu.style.transform = 'translateY(-100%)';
        menu.style.zIndex = '-1';
      })
      submenus[index].style.transform = 'translateY(0px)';
      submenus[index].style.zIndex = 'unset';

      submenus[index].addEventListener('mouseleave', () => {
        submenus[index].style.transform = 'translateY(-100%)';
      })
    })
  })

  menuIcon.addEventListener('click', () => {
    mobileNavi.classList.toggle('header-mobile--active');
    closeIcon.classList.toggle('header-mobile__close--active');
    hamburgerIcon.classList.toggle('header-mobile__hamburger--active');
  })

  closeIcon.addEventListener('click', () => {
    mobileNavi.classList.toggle('header-mobile--active');
    closeIcon.classList.toggle('header-mobile__close--active');
    hamburgerIcon.classList.toggle('header-mobile__hamburger--active');
  })

  dropdowns.forEach((dropdown, index) => {
    dropdown.addEventListener('click', () => {
      mobileSubmenus.forEach(submenu => {
        if(submenu.classList.contains('header-mobile__submenu--active') && submenu !== mobileSubmenus[index]){
          submenu.classList.remove('header-mobile__submenu--active');
        }
      })

      dropdowns.forEach(singleDropdown => {
        if(singleDropdown.classList.contains('header-mobile__icon--active') && singleDropdown !== dropdown){
          singleDropdown.classList.remove('header-mobile__icon--active');
        }
      })


      mobileSubmenus[index].classList.toggle('header-mobile__submenu--active');
      dropdown.classList.toggle('header-mobile__icon--active');
    })
  })
});